(function() {
  var address1 = document.getElementById('address-address1');
  var addressEdit1 = document.getElementById('address-address-edit1');
  var address2 = document.getElementById('address-address2');
  var addressEdit2 = document.getElementById('address-address-edit2');
  var btnAddAddress = document.querySelector('.add-address-btn');
  var countErrInput = 0;

  function errStyleInput(elem) {
    elem.style.borderColor = 'red';
    elem.style.color = 'red';
    var p = document.createElement('p');
    p.style.color = 'red';
    p.classList.add('err_massage');
    var parentElem = elem.parentElement;
    p.innerText = 'Non US keyboard layout symbols are not allowed. Please replace them with US en symbols';
    parentElem.appendChild(p)
    btnAddAddress.disabled = true;
    countErrInput++;
  }
  function succStyleInput(elem) {
    elem.style.borderColor = '#d8d7d5';
    elem.style.color = '#212121';
    var parent = elem.parentElement;
    var errMessage = parent.querySelector('.err_massage');
    if (errMessage) {
      errMessage.remove()
      countErrInput--;
      if (!countErrInput) {
        btnAddAddress.disabled = false;
      }
    }
  }


  const validateBlur = (elem) => {
    return function (event) {
      var value = event.target.value;
      var regexp = /[^A-Za-z0-9\s\'\-]/ig;
      var isNotValid = regexp.test(value);
      if (isNotValid) {
        errStyleInput(elem);
      }
    }

  }

  const validateFocus = (elem) => {
    return function (event) {
      succStyleInput(elem);
    }
  }
  if (address1) {
    address1.addEventListener('blur', validateBlur(address1));
    address1.addEventListener('focus', validateFocus(address1));
  }

  if (addressEdit1) {
    addressEdit1.addEventListener('blur', validateBlur(addressEdit1));
    addressEdit1.addEventListener('focus', validateFocus(addressEdit1));
  }

  if (address2) {
    address2.addEventListener('blur', validateBlur(address2));
    address2.addEventListener('focus', validateFocus(address2));
  }

  if (addressEdit2) {
    addressEdit2.addEventListener('blur', validateBlur(addressEdit2));
    addressEdit2.addEventListener('focus', validateFocus(addressEdit2));
  }
})()
